import PendoFilterBar from '../../components/filter-bar/pendo-filter-bar.vue.js';
import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoDrawer from '../../components/drawer/pendo-drawer.vue.js';
import PendoAppDisplay from '../app-display/pendo-app-display.vue.js';
import PendoIconOption from '../../components/multiselect/option-types/pendo-icon-option.vue.js';
import PendoMultiselect from '../../components/multiselect/pendo-multiselect.vue.js';
import PendoLayoutGrid from './pendo-layout-grid.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import Defer from '../../mixins/defer.js';
import PendoAffix from '../../directives/affix/pendo-affix.js';

var script = {
  name: 'PendoLayoutChooser',
  components: {
    PendoAppDisplay,
    PendoCard,
    PendoDrawer,
    PendoFilterBar,
    PendoIconOption,
    PendoLayoutGrid,
    PendoMultiselect
  },
  directives: {
    PendoAffix,
    PendoTooltip
  },
  mixins: [Defer()],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    layouts: {
      type: Array,
      default: null
    },
    defaultLayouts: {
      type: Array,
      default: null
    },
    defaultLayoutsTitle: {
      type: String,
      default: 'Default'
    },
    customLayouts: {
      type: Array,
      default: null
    },
    customLayoutsTitle: {
      type: String,
      default: 'Saved'
    },
    organizationLayouts: {
      type: Array,
      default: null
    },
    organizationLayoutsTitle: {
      type: String,
      default: 'Organization'
    },
    title: {
      type: String,
      default: 'Create Guide'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: [Object, Array],
      default: () => [{
        prop: ['title'],
        value: ''
      }]
    },
    loading: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    zIndex: {
      type: Number,
      default: 502
    },
    apps: {
      type: Array,
      default: null
    },
    useAppDisplay: {
      type: Boolean,
      default: false
    },
    selectedApp: {
      type: Object,
      default: null
    },
    themes: {
      type: Array,
      default: null
    },
    selectedTheme: {
      type: Object,
      default: null
    },
    guideCategories: {
      type: Array,
      default: null
    },
    selectedGuideCategory: {
      type: Object,
      default: null
    },
    emptyOption: {
      type: Object,
      default: null
    },
    appendTo: {
      type: [String, Element, Boolean],
      default: 'body'
    }
  },
  data() {
    return {
      isDrawerOpening: false
    };
  },
  computed: {
    isVisible: {
      get() {
        if (this.$options.propsData.visible == null) {
          return true;
        }
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
        if (!val) {
          this.$emit('close');
          this.$emit('onClose');
        }
      }
    },
    appThemeCardTitle() {
      const title = [];
      if (this.$slots.appChooser || this.apps) {
        title.push('Application');
      }
      if (this.$slots.themeChooser || this.themes) {
        title.push('Theme');
      }
      return title.join(' & ');
    }
  },
  methods: {
    showAppThemeCard() {
      return this.apps || this.themes || this.$slots.appChooser || this.$scopedSlots.appChooser || this.$slots.themeChooser || this.$scopedSlots.themeChooser;
    },
    handleDrawerOpen() {
      this.isDrawerOpening = true;
    },
    handleDrawerOpened() {
      this.isDrawerOpening = false;
    },
    selectApp(app) {
      this.$emit('select-app', app);
    },
    selectTheme(theme) {
      this.$emit('select-theme', theme);
    },
    selectGuideCategory(category) {
      this.$emit('select-guide-category', category);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-layout-chooser.vue2.js.map
